/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.masterTools").
controller("DxMasterToolsMoveUserDataController", function MasterToolsMoveUserDataController(
	$scope,

	NodeRepository,
	Node,
	dxApi
) {
	"use strict";

	$scope.fromNode = null;
	$scope.toNode = null;
	$scope.nodes = [];
	$scope.error = "";
	$scope.moveInfo = null;

	NodeRepository.list().then(function success(response) {
		return Array.from(response.nodes).map(function nodes(n) {
			return $scope.nodes.push(new Node(n));
		});
	});

	function failed(error) {
		$scope.error = error.data.msgs[0];
	}

	$scope.continueToVerification = function continueToVerification() {
		$scope.finalMessage = null;
		$scope.error = null;

		function success(info) {
			$scope.moveInfo = info;
		}

		return dxApi.legacy.masterTools.info($scope.email, $scope.fromNode.id, $scope.toNode.id).then(success, failed);
	};

	$scope.cancel = function cancel() {
		$scope.moveInfo = null;
		$scope.finalMessage = null;
	};

	$scope.performMove = function performMove() {
		$scope.finalMessage = "Moving data...";

		function success() {
			$scope.finalMessage = "The data has been moved";
		}

		return dxApi.legacy.masterTools.perform($scope.email, $scope.fromNode.id, $scope.toNode.id).then(success, failed);
	};
});
